import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { RadioButtonGroupInput, useTranslate } from "react-admin";
import { useFormContext } from "react-hook-form";
import { TextModel } from "../GeneratedClients/FreeBillApi";

const RadioButtonTextModel = ({setShowTextModel, textModel} : {
  textModel?: TextModel, 
  setShowTextModel: Dispatch<SetStateAction<"show" | "hide" | undefined>>
}) => {
  const { setValue } = useFormContext()
  const translate = useTranslate()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setShowTextModel(event.target.value as "show" | "hide");
    setValue("textModel", event.target.value === "hide" ? null : textModel)
  }

  return (
    <RadioButtonGroupInput 
      onChange={handleChange}
      helperText={false}
      label={false}
      source="configTextModel"
      choices={[
        { id: 'hide', name: translate('resources.textTemplates.action.hideTextModel')},
        { id: 'show', name: translate('resources.textTemplates.action.showTextModel')},
      ]}
    />
  )
}

export default RadioButtonTextModel